export function IconChevronDownFilled() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="relative text-[#1D252C]"
    >
      <path
        d="M17.6381 5.83417L17.6381 9.33646L10.9716 15.8335L4.30473 9.33613L4.30473 5.83539L4.30657 5.83348L10.9716 12.3303L17.6374 5.83348L17.6381 5.83417Z"
        fill="currentColor"
      />
    </svg>
  );
}
